import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import styled from 'styled-components'
import ArrowLeftIcon from '@ucheba/ui/icons/icon__arrow-left-filled.svg'
import { Button } from '@ucheba/ui/components/Button/desktop'
import Link from 'next/link'
import {
  useSectionSlug,
  useSpecialitiesPageHeaderCore,
  useSpecialitiesPageRubricsCore,
} from '../bll'
import SpecialitiesPageSectionsNavigation from './SpecialitiesPageSectionsNavigation'
import SpecialitiesPageSearchForm from './SpecialitiesPageSearchForm'
import SpecialitiesPageSearchByEge from './SpecialitiesPageSearchByEge'
import { ISpecialitiesPageHeaderProps } from '../types'

const GridColSC = styled(GridCol)`
  flex-grow: 1;
`

const SpecialitiesPageHeader: FC<ISpecialitiesPageHeaderProps> = ({ title, href }) => {
  const { isInstitutionsSection } = useSectionSlug()
  const { mainHeadingProps } = useSpecialitiesPageHeaderCore()

  const { isShowHeading, backHref, parentRubricTitle } = useSpecialitiesPageRubricsCore()

  return (
    <>
      <Spacing spacing='xxlarge' />

      <Grid spacing='small'>
        <GridCol width='300px'>
          <SpecialitiesPageSectionsNavigation href={href} />
        </GridCol>

        <GridColSC width='auto'>
          <Grid spacing='small'>
            <GridColSC width='auto'>
              <SpecialitiesPageSearchForm />
            </GridColSC>

            {isInstitutionsSection && (
              <GridCol width='auto'>
                <SpecialitiesPageSearchByEge />
              </GridCol>
            )}
          </Grid>
        </GridColSC>
      </Grid>

      <Spacing spacing='large' />

      {isShowHeading ? (
        <Grid alignItems='baseline' spacing='xxsmall' nowrap>
          <GridCol width='auto'>
            <Link href={backHref}>
              <Button icon size='small' shape='circle'>
                <ArrowLeftIcon width='24px' height='24px' />
              </Button>
            </Link>
          </GridCol>

          <GridCol width='auto' shrink='initial'>
            <Heading h1={parentRubricTitle} as='h1' firstLetterUppercase spacing='null' />
          </GridCol>
        </Grid>
      ) : (
        <Heading
          h1={title || mainHeadingProps.h1}
          as={title ? 'h1' : (mainHeadingProps.as as any)}
          spacing='xxsmall'
        />
      )}
    </>
  )
}

export default memo(SpecialitiesPageHeader)
